module.exports = __webpack_public_path__ + "images/261ec4844d867502dbd7365c6887f727.png";